<script setup lang="ts">
interface Props {
  value: boolean
}

const props = defineProps<Props>()

const emit = defineEmits<{
  (e: 'input', value: boolean): void
}>()

function handleInputChange(value: boolean): void {
  emit('input', value)
}
</script>

<template>
  <div>
    <v-radio-group :value="props.value" hide-details column @change="handleInputChange">
      <v-radio :value="true" label="Yes" class="radio-item"></v-radio>
      <v-radio :value="false" label="No" class="radio-item"></v-radio>
    </v-radio-group>
  </div>
</template>

<style scoped>
.radio-item {
  padding-bottom: 8px;
}
</style>
